/**
 * Assessment report narrative sections per docs/apis/editor-save.md.
 * Order, section id, title, and report object field name.
 */
export const ASSESSMENT_REPORT_NARRATIVE_SECTIONS = [
  { id: 'clinical_interpretation', title: 'Clinical Interpretation', field: 'clinicalInterpretation' },
  { id: 'functional_impact', title: 'Functional Impact', field: 'functionalImpact' },
  { id: 'clinical_observations', title: 'Clinical Observations', field: 'clinicalObservations' },
  { id: 'provisional_clinical_impression', title: 'Provisional Clinical Impression', field: 'provisionalClinicalImpression' },
  { id: 'recommendations', title: 'Recommendations', field: 'recommendations' },
  { id: 'free_form_rich_text', title: 'Free-form Rich Text', field: 'freeFormRichText' },
]
